import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import './style.scss'
import {
  FormCheckbox,
  FormSelect,
  Modal,
  ModalBody,
  ModalHeader,
  InputGroup,
  InputGroupAddon,
  FormInput,
  Button, InputGroupText
} from "shards-react";
import {Link} from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import PageTitle from "../../../components/common/PageTitle";
import {ChromePicker} from "react-color";
import {toast} from "react-toastify";
import _ from "underscore";

const selectingProps = [
  {"key" : "newest", "label": "최신순"},
  {"key" : "grade", "label": "평점순"},
  {"key" : "specify", "label": "지정"},
  {"key" : "specify_product", "label": "지정(상품별)"},
];

const displayAreaProps = [
  {"key" : "main", "label": "메인(인덱스) 페이지"},
  {"key" : "list", "label": "리스트 페이지(하단)"},
  {"key" : "detail_top", "label": "상세 페이지 상단(해당상품)"},
  {"key" : "detail_top_all", "label": "상세 페이지 상단(전체상품)"},
  {"key" : "board_top", "label": "후기 페이지 상단"},
  // {"key" : "detail_bottom", "label": "상세 페이지 하단"},
  {"key" : "code", "label": "코드로 사용"},
];

const colProps = [
  {"key" : 2, "label": 2},
  {"key" : 3, "label": 3},
  {"key" : 4, "label": 4},
  {"key" : 5, "label": 5},
  {"key" : 6, "label": 6},
];

const rowProps = [
  {"key" : 1, "label": 1},
  {"key" : 2, "label": 2},
  {"key" : 3, "label": 3},
];

const booleanProps = [
  {"key" : true, "label": "사용함"},
  {"key" : false, "label": "사용안함"},
];

const booleanDisProps = [
  {"key" : false, "label": "노출안함"},
  {"key" : true, "label": "노출"},
];

const reviewTypeProps = [
  {"key" : "photo", "label": "포토"},
  {"key" : "text", "label": "텍스트"},
  {"key" : "all", "label": "텍스트+포토"},
];

const defaultStyle = {
  marginTop: 30,
  marginBottom: 30,
}

const defaultHeadStyle =  {
  textAlign: 'left',
  color: '#000000',
  size: 23,
  marginTop: 0,
  marginBottom: 30,
  lrPadding:0
}



@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ widget }) => ({ updateWidget: widget.updateWidget, getWidgetList:widget.getWidgetList, removeWidget:widget.removeWidget }))
@inject(({ common }) => ({ updateDoc: common.updateDoc, getDoc: common.getDoc, fetchPageHtml: common.fetchPageHtml }))

@observer
class widgetList extends Component {

  @observable shopUser = {};
  @observable shopInfo = {};
  @observable emailId = '';
  @observable isLogin = false;

  @observable isShowMColor_1 = false;
  @observable colorPickerPos_1 = { top: 0, left: 0 };
  colorSwatchRef_1 = React.createRef();

  @observable isShowMColor_2 = false;
  @observable colorPickerPos_2 = { top: 0, left: 0 };
  colorSwatchRef_2 = React.createRef();

  @observable editingNameId = null;
  @observable editingNameValue = '';

  @observable makeWidgetProps = {
    "basic": {label: "일반 리뷰", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps, reviewType: reviewTypeProps},
    "slider": {label: "슬라이드 리뷰", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps, reviewType: reviewTypeProps},
    "purchase_review": {label: "실시간 주문", selecting: selectingProps, displayArea: displayAreaProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps},
    // "analysis": {label: "분석 위젯", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps},
    // "ai_floating": {label: "AI 분석 위젯", selecting: selectingProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps},
    // "media": {"label": "포토 리뷰", "selecting": selectingProps, "displayArea": displayAreaProps, "row": rowProps, "col": colProps, "isAutoPlay": booleanProps},
    // "movie": {"label": "영상 리뷰", "selecting": selectingProps, "displayArea": displayAreaProps, "row": rowProps, "col": colProps, "isAutoPlay": booleanProps},
    // "reviewList": {"label": "실시간 리뷰 목록 위젯"},
    //"buyAlam": {"label": "구입 알림 위젯"},
    // "reviewAlam": {"label": "리뷰 알림 위젯"},
    // "writableReview": {"label": "리뷰작성유도 위젯"},
  };

  @observable newWidgetProps = this.makeWidgetProps.basic;

  @observable newWidget = {};
  @observable curWidget = {
    style:{ style: defaultStyle },
    head:{ style: defaultHeadStyle },
    display: {
      rating: true,
      count: true
    }
  };

  // 그리드 위젯 추가 모달 열기 — 선택된 페이지 탭에 맞춰 노출 영역을 미리 선택해 준다
  openNewWidgetModal = () => {
    const tabToArea = { main: 'main', list: 'list', detail: 'detail_top', board: 'board_top', code: 'code' };
    if (tabToArea[this.widgetPageTab]) {
      this.newWidget.displayArea = tabToArea[this.widgetPageTab];
    }
    this.modals.isNewWidget = true;
  };

  //list
  @observable listParams = {
    page:1, limit:20,
  }
  @observable list = [];

  //modals
  @observable modals = {
    isNewWidget: false,
    isWidgetHeadSetiing: false
  };

  @observable expandedCard = null;
  @observable moreMenuOpen = null;
  // 카드별 저장되지 않은 변경사항 추적
  @observable dirtyWidgetIds = [];
  // revert 용 스냅샷 (widgetId -> 원본 JSON 문자열)
  widgetSnapshots = {};
  @observable widgetTypeFilter = '';
  @observable widgetStatusFilter = '';
  @observable widgetKeyword = '';
  @observable widgetPageTab = 'main'; // 페이지별 탭 (all | main | list | detail | board | etc)
  @observable showBanner = true;
  @observable curDetailTab = 'basic';

  // 위치 선택기
  @observable selectorPickerOpen = false;
  @observable selectorPickerLoading = false;
  @observable selectorPickerHtml = '';
  @observable selectorPickerSelected = '';
  @observable selectorPickerUrl = '';

  constructor(props) {
    super(props);
    this.init()

    this.onChangeValue = this.onChangeValue.bind(this);

    // onChangeDataValue 의 빠른 연속 변경을 묶어 한 번에 저장하기 위한 debounce 인프라.
    this._pendingUpdates = {};
    this._debouncedSaves = {};
  }

  componentWillUnmount() {
    Object.keys(this._debouncedSaves || {}).forEach(id => {
      try { this._debouncedSaves[id].flush && this._debouncedSaves[id].flush(); } catch(e) {}
    });
  }


  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      this.permissions = this.props.me.permissions;

      // this.props.getDoc('getDesignConfig', {store_id: this.teamUser.selStore_id}, function(res) {
      //   if(res.errors && res.errors.length > 0) {
      //     alert(res.errors[0].message);
      //   }
      //   else {
      //     let results;
      //     if(res && res.data) {
      //       results = res.data;
      //       //console.log(results);
      //       if(results.store_id) {
      //         _this.basicWidget = results.commons ? results.commons : _this.basicWidget;
      //         _this.display = results.display ? results.display : _this.display;
      //       }
      //     }
      //   }
      // });
      this.getBasicSettings();
      this.newWidget = {
        shopNo : this.teamUser.selShopNo ? this.teamUser.selShopNo :1,
        title: '',
        type: 'basic',
        selecting: 'newest',
        displayArea: 'main',
        col: 4,
        row: 1,
        isAutoPlay: 'true',
        reviewType: 'photo',
        style:{ style: defaultStyle },
        head:{ style: defaultHeadStyle }
      }
      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo :1;
      this.getWidgetList();
    }
  };

  getBasicSettings = async() => {
    let _this = this;
    this.props.getDoc('getBasicSettings', {store_id: this.teamUser.selStore_id}, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        if(res && res.data) {
          _this.basicWidget = res.data;
        }
      }
    });
  };

  getWidgetList = async() => {
    if(this.listParams.store_id) {
      this.list = await this.props.getWidgetList(this.listParams);
      // 저장 후 목록을 새로 받아오면 기존 위젯 객체가 새 객체로 교체되어 curWidget 참조가 분리(detach)된다.
      // 이 경우 편집 폼(this.curWidget)과 저장 버튼이 넘기는 목록 item 이 서로 다른 객체가 되어,
      // 재수정한 내용이 저장되지 않는다. 같은 _id 의 새 객체로 curWidget 을 다시 연결한다.
      if (this.curWidget && this.curWidget._id && this.list && this.list.docs) {
        const fresh = this.list.docs.find(d => d._id === this.curWidget._id);
        if (fresh) {
          if (!fresh.style) fresh.style = {};
          if (!fresh.head) fresh.head = { title: fresh.title || '', style: {} };
          if (!fresh.head.style) fresh.head.style = {};
          if (!fresh.head.subtitleStyle) fresh.head.subtitleStyle = {};
          if (!fresh.display) fresh.display = { rating: true, count: true };
          this.curWidget = fresh;
        }
      }
      this.isLoading = false;
    }
    else {
      //console.log('null store_id');
    }
  };


  onChangeValue = async (event, targetObj) => {
    const { name, value } = event.target;
    if(targetObj) {
      if(name === "isTitleDis") {
        targetObj[name] = value === "true";
      }
      else if(name === "rating" || name === "count") {
        targetObj[name] = value === "false";
      }
      else {
        targetObj[name] = value;
      }
      this.markWidgetDirty(this.curWidget);
    }
  };

  // dirty 상태 추적 — 변경된 위젯을 알 수 있게 표시
  markWidgetDirty = (widget) => {
    if (!widget || !widget._id) return;
    const id = widget._id;
    if (this.dirtyWidgetIds.indexOf(id) === -1) {
      this.dirtyWidgetIds.push(id);
      // 최초 dirty 시 스냅샷 저장 (revert 용)
      if (!this.widgetSnapshots[id]) {
        try { this.widgetSnapshots[id] = JSON.stringify(widget); } catch (e) {}
      }
    }
  };

  startEditName = (item, e) => {
    if (e) e.stopPropagation();
    this.editingNameId = item._id;
    this.editingNameValue = item.title || '';
  };

  commitEditName = (item) => {
    if (this.editingNameId !== item._id) return;
    const newTitle = (this.editingNameValue || '').trim();
    if (newTitle && newTitle !== item.title) {
      item.title = newTitle;
      this.markWidgetDirty(item);
    }
    this.editingNameId = null;
    this.editingNameValue = '';
  };

  cancelEditName = () => {
    this.editingNameId = null;
    this.editingNameValue = '';
  };

  handleNameKeyDown = (e, item) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.commitEditName(item);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      this.cancelEditName();
    }
  };

  isWidgetDirty = (id) => this.dirtyWidgetIds.indexOf(id) !== -1;

  clearWidgetDirty = (id) => {
    this.dirtyWidgetIds = this.dirtyWidgetIds.filter(x => x !== id);
    delete this.widgetSnapshots[id];
  };

  // revert — 스냅샷으로 widget 복원
  revertWidget = (item) => {
    const id = item && item._id;
    if (!id || !this.widgetSnapshots[id]) return;
    try {
      const snap = JSON.parse(this.widgetSnapshots[id]);
      Object.keys(snap).forEach(k => { item[k] = snap[k]; });
    } catch (e) {}
    this.clearWidgetDirty(id);
  };

  updateWidget = async () => {
    let _this = this;

    if(!_this.newWidget.title) {
      alert('제목을 입력해 주세요.');
      return false;
    }

    if(_this.newWidget.row) {
      _this.newWidget.row = parseInt(_this.newWidget.row);
    }
    if(_this.newWidget.col) {
      _this.newWidget.col = parseInt(_this.newWidget.col);
    }
    // if(_this.newWidget.type === 'slider') {
    //   _this.newWidget.dataPer = 2;
    // }

    let tempNewWidget = {..._this.newWidget}
    tempNewWidget.store_id = _this.teamUser.selStore_id;
    tempNewWidget.title = _this.newWidget.title;

    // for(let key in _this.newWidgetProps) {
    //   tempNewWidget[key] = _this.newWidget[key];
    // }



    if(!tempNewWidget.head) {
      tempNewWidget.head = {
        style: defaultHeadStyle
      }
    }
    if(!tempNewWidget.head.title) {
      tempNewWidget.head.title = tempNewWidget.title;
    }


    console.log(tempNewWidget)
    this.props.updateWidget(tempNewWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        _this.modals.isNewWidget = false;
        _this.getWidgetList();
        //window.location.reload();
      }

    });
  };


  onChangeDataValue = (item, event) => {
    const { name, value } = event.target;
    let coerced = value;
    if (name === 'row' || name === 'col' || name === 'dataPer') {
      coerced = parseInt(value);
    }
    item[name] = coerced;

    if (!this._pendingUpdates[item._id]) {
      this._pendingUpdates[item._id] = {
        id: item._id,
        store_id: this.teamUser.selStore_id,
        _title: item.title
      };
    }
    this._pendingUpdates[item._id][name] = coerced;
    this._pendingUpdates[item._id]._title = item.title;

    if (!this._debouncedSaves[item._id]) {
      this._debouncedSaves[item._id] = _.debounce((widgetId) => this._flushDataSave(widgetId), 400);
    }
    this._debouncedSaves[item._id](item._id);
  };

  _flushDataSave = (widgetId) => {
    const pending = this._pendingUpdates[widgetId];
    if (!pending) return;
    delete this._pendingUpdates[widgetId];
    const title = pending._title || '';
    delete pending._title;

    let _this = this;
    this.props.updateWidget(pending, function(res) {
      if (res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        toast('"' + title + '" 위젯 수정이 완료되었습니다.');
        _this.getWidgetList();
      }
    });
  };

  onChangeStyleValue = async (item) => {
    let _this = this;

    item.head.style.marginTop = 0;
    let updateWidget = {
      id: item._id,
      title: item.title,
      store_id: this.teamUser.selStore_id,
      isTitleDis: item.isTitleDis === true,
      style: item.style,
      head: item.head,
      display: item.display,
    };

    // 슬라이더 타입인 경우 슬라이드 설정 추가
    if (item.slideDelay) {
      updateWidget.slideDelay = parseInt(item.slideDelay);
    }
    if (item.slidesToScroll) {
      updateWidget.slidesToScroll = parseInt(item.slidesToScroll);
    }
    if (item.mobileSlidesPerView) {
      updateWidget.mobileSlidesPerView = parseInt(item.mobileSlidesPerView);
    }

    this.props.updateWidget(updateWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        toast('"' + item.title + '" 위젯 수정이 완료되었습니다.');
        _this.modals.isWidgetHeadSetiing = false;
        _this.clearWidgetDirty(item._id);
        _this.getWidgetList();
      }

    });
  };

  // updateBasicWidget = async (target) => {
  //
  //   let data = this.basicWidget;
  //   data.store_id = this.teamUser.selStore_id;
  //   this.props.updateDoc('updateBasicSettings', data, function(res) {
  //     if(res.errors && res.errors.length > 0) {
  //       toast(res.errors[0].message);
  //     }
  //     else {
  //       toast('저장 되었습니다.');
  //     }
  //     //todo 페이지 새로 고침
  //   });
  // };



  onCopyWidgetCode = async (item) => {
    let htmlCode = '<div id="orvwig-' + item._id +'" widget_id="' + item._id +'" class="onreview-code-widget" style="display: none;"></div>';
    window.navigator.clipboard.writeText(htmlCode).then(() => {
      // 복사가 완료되면 이 부분이 호출된다.
      alert('코드가 복사 되었습니다. ( pc, 모바일 모두 사용가능합니다. )');
    });
  };

  onShowReviews = async (item) => {
    window.open('/reviewList?widget_id=' + item._id);
  };

  onRemoveWidget = async (item) => {
    let _this = this;

    let delWidget = {
      id: item._id,
      store_id: this.teamUser.selStore_id
    };

    this.props.removeWidget(delWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        _this.getWidgetList();
      }

    });

  };

  editHeadModalOpen = async (item) => {
    if(!item.style) {
      item.style = defaultStyle;
    }
    if(!item.head) {
      item.head = {
        title : item.title,
        style : defaultHeadStyle
      }
    }
    if(!item.head.subtitleStyle) item.head.subtitleStyle = {};
    if(!item.display) {
      item.display = {
        rating: true,
        count: true
      };
    }
    this.curWidget = item;
    this.modals.isWidgetHeadSetiing = true;
  };

  modalToggle = function(target, data) {
    if(this.isShowMColor_1) {
      this.isShowMColor_1 = false;
    }
    // this.modals[target] = !this.modals[target];
    // if(!target) {
    //   for( var i in this.modals) {
    //     this.modals[i] = false;
    //   }
    // }
    if(data) {
      this.modals.data = data;
    }
  };

  onChangeColor =  async (name, color, targetObj) => {
    targetObj[name] = color.hex;
    this.markWidgetDirty(this.curWidget);
  };

  showColorModalFn =  async (targetModal) => {
    if(targetModal) {
      const idx = targetModal.split('_')[1] || '1';
      const ref = this['colorSwatchRef_' + idx];
      if (ref && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const pickerWidth = 225;
        const pickerHeight = 260;
        let left = rect.left;
        let top = rect.bottom + 8;
        if (left + pickerWidth > window.innerWidth - 8) {
          left = window.innerWidth - pickerWidth - 8;
        }
        if (left < 8) left = 8;
        if (top + pickerHeight > window.innerHeight - 8) {
          top = rect.top - pickerHeight - 8;
        }
        if (top < 8) top = 8;
        this['colorPickerPos_' + idx] = { top, left };
      }
      this[targetModal] = true;
    }
    else {
      this.isShowMColor_1 = false;
    }
  };

  @action
  toggleCardExpand = (id) => {
    this.expandedCard = this.expandedCard === id ? null : id;
    // 펼친 카드를 curWidget 으로 동기화 → 세부 설정이 해당 카드를 대상으로 동작
    if (this.expandedCard) {
      const item = (this.list && this.list.docs ? this.list.docs : []).find(x => x._id === id);
      if (item) {
        // 누락 필드 보정 (기존 editHeadModalOpen 의 안전장치 일부 적용)
        if (!item.style) item.style = {};
        if (!item.head) item.head = { title: item.title || '', style: {} };
        if (!item.head.style) item.head.style = {};
        if (!item.head.subtitleStyle) item.head.subtitleStyle = {};
        if (!item.display) item.display = { rating: true, count: true };
        this.curWidget = item;
      }
    }
  };

  @action
  toggleMoreMenu = (id) => {
    this.moreMenuOpen = this.moreMenuOpen === id ? null : id;
  };

  // === 위치 선택기 ===
  @action
  openSelectorPicker = async () => {
    const domain = (this.teamUser && this.teamUser.shop && this.teamUser.shop.primaryDomain)
      ? this.teamUser.shop.primaryDomain
      : (this.store && this.store.platformId ? this.store.platformId + '.cafe24.com' : '');
    if (!domain) {
      toast.error ? toast.error('쇼핑몰 도메인을 확인할 수 없습니다.') : alert('쇼핑몰 도메인을 확인할 수 없습니다.');
      return;
    }
    const url = 'https://' + domain;
    this.selectorPickerUrl = url;
    this.selectorPickerOpen = true;
    this.selectorPickerLoading = true;
    this.selectorPickerSelected = '';
    try {
      const res = await this.props.fetchPageHtml(url);
      if (res && res.dataString) {
        // base 태그 삽입으로 상대경로 리소스 해결 + 스크립트 제거
        let html = res.dataString;
        html = html.replace(/<script[\s\S]*?<\/script>/gi, '');
        html = html.replace(/<head>/i, '<head><base href="' + url + '/" />');
        this.selectorPickerHtml = html;
      } else {
        this.selectorPickerHtml = '<div style="padding:40px;text-align:center;color:#94A3B8;">페이지를 불러올 수 없습니다.</div>';
      }
    } catch (e) {
      this.selectorPickerHtml = '<div style="padding:40px;text-align:center;color:#EF4444;">페이지 로딩 중 오류가 발생했습니다.</div>';
    }
    this.selectorPickerLoading = false;
  };

  @action
  closeSelectorPicker = () => {
    this.selectorPickerOpen = false;
    this.selectorPickerHtml = '';
  };

  @action
  applySelectorFromPicker = () => {
    if (this.selectorPickerSelected && this.curWidget && this.curWidget.style) {
      this.curWidget.style.parentSelector = this.selectorPickerSelected;
    }
    this.closeSelectorPicker();
  };

  // iframe 로드 후 클릭 이벤트 바인딩
  setupPickerIframe = (iframe) => {
    if (!iframe) return;
    const _this = this;
    iframe.onload = () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        // 모든 링크/폼 비활성화
        const links = doc.querySelectorAll('a, form');
        links.forEach(el => {
          el.addEventListener('click', e => e.preventDefault());
          el.addEventListener('submit', e => e.preventDefault());
        });
        // 호버 하이라이트 + 클릭으로 셀렉터 추출
        let lastHighlight = null;
        doc.body.addEventListener('mouseover', (e) => {
          if (lastHighlight) {
            lastHighlight.style.outline = '';
            lastHighlight.style.outlineOffset = '';
          }
          e.target.style.outline = '2px solid #4A6CF7';
          e.target.style.outlineOffset = '-2px';
          lastHighlight = e.target;
        });
        doc.body.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const el = e.target;
          // 셀렉터 생성: id > class > tag path
          let selector = '';
          if (el.id) {
            selector = '#' + el.id;
          } else if (el.className && typeof el.className === 'string' && el.className.trim()) {
            selector = '.' + el.className.trim().split(/\s+/).join('.');
          } else {
            selector = el.tagName.toLowerCase();
            let parent = el.parentElement;
            let depth = 0;
            while (parent && parent !== doc.body && depth < 3) {
              let prefix = parent.tagName.toLowerCase();
              if (parent.id) { prefix = '#' + parent.id; selector = prefix + ' > ' + selector; break; }
              if (parent.className && typeof parent.className === 'string') prefix += '.' + parent.className.trim().split(/\s+/)[0];
              selector = prefix + ' > ' + selector;
              parent = parent.parentElement;
              depth++;
            }
          }
          _this.selectorPickerSelected = selector;
        });
      } catch (err) {
        console.error('iframe 접근 오류:', err);
      }
    };
  };

  // 카드 expand 영역에 노출되는 세부 설정 (탭 구조)
  renderDetailedSettings = () => {
    if (!this.curWidget || !this.curWidget._id) return null;
    const _this = this;
    const isSlider = this.curWidget.type === 'slider';
    const tabs = [
      { key: 'basic',   icon: 'settings', label: '기본' },
      { key: 'layout',  icon: 'layout',   label: '레이아웃' },
    ];
    if (isSlider) tabs.push({ key: 'slide', icon: 'sliders', label: '슬라이드' });
    const active = tabs.some(t => t.key === this.curDetailTab) ? this.curDetailTab : 'basic';

    return (
      <div className="wl-card__details-wrap">
        <div className="wl-card__details">
          {/* Tab bar */}
          <div className="wl-detail-tabs" role="tablist">
            {tabs.map(t => (
              <button
                key={t.key}
                type="button"
                role="tab"
                aria-selected={active === t.key}
                className={`wl-detail-tabs__btn${active === t.key ? ' is-active' : ''}`}
                onClick={() => { this.curDetailTab = t.key; }}
              >
                <FeatherIcon icon={t.icon} size="14" />
                <span>{t.label}</span>
              </button>
            ))}
          </div>

          {/* 기본 — 리뷰/위젯 데이터 항목 (리뷰 타입, 리뷰 선택, 종류, 노출 영역, 라인 수, 라인당 리뷰수, 리뷰 노출수, 평점/리뷰수 노출) */}
          {active === 'basic' && (
            <div className="wl-detail-pane">
              <div className="wl-card__expand-grid">
                <div className="wl-field">
                  <label className="wl-field__label">리뷰 타입</label>
                  <FormSelect name="reviewType" value={this.curWidget.reviewType || 'photo'}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {reviewTypeProps.map((opt, k) => (
                      <option key={k} value={opt.key}>{opt.label}</option>
                    ))}
                  </FormSelect>
                </div>
                <div className="wl-field">
                  <label className="wl-field__label">리뷰 선택</label>
                  <FormSelect name="selecting" value={this.curWidget.selecting}
                              disabled={this.curWidget.selecting === 'ai' || this.curWidget.selecting === 'analysis'}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {selectingProps.map((opt, k) => (
                      <option key={k} value={opt.key} disabled={this.curWidget.selecting === 'analysis'}>{opt.label}</option>
                    ))}
                  </FormSelect>
                </div>
                <div className="wl-field">
                  <label className="wl-field__label">노출 영역</label>
                  <FormSelect name="displayArea" value={this.curWidget.displayArea}
                              disabled={this.curWidget.displayArea === "product_floating"}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {displayAreaProps.map((opt, k) => (
                      <option key={k} value={opt.key} disabled={this.curWidget.selecting === 'analysis' && opt.key !== 'code'}>{opt.label}</option>
                    ))}
                  </FormSelect>
                </div>
                <div className="wl-field">
                  <label className="wl-field__label">종류</label>
                  <FormSelect name="type" value={this.curWidget.type}
                              disabled={this.curWidget.type === 'ai_floating'}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {Object.keys(this.makeWidgetProps).map((key) => (
                      <option key={key} value={key} disabled={key !== "analysis" && this.curWidget.type === "analysis"}>{this.makeWidgetProps[key].label}</option>
                    ))}
                  </FormSelect>
                </div>
                <div className="wl-field">
                  <label className="wl-field__label">라인 수</label>
                  <FormSelect name="row" value={this.curWidget.row}
                              disabled={this.curWidget.type === 'ai_floating'}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {[1,2,3].map(n => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </FormSelect>
                </div>
                <div className="wl-field">
                  <label className="wl-field__label">라인당 리뷰수</label>
                  <FormSelect name="col" value={this.curWidget.col}
                              disabled={this.curWidget.type === 'ai_floating'}
                              onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                    {[1,2,3,4,5,6].map(n => (
                      <option key={n} value={n}>{n}</option>
                    ))}
                  </FormSelect>
                </div>
                {isSlider && (
                  <div className="wl-field">
                    <label className="wl-field__label">리뷰 노출수</label>
                    <FormSelect name="dataPer" value={this.curWidget.dataPer}
                                onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                      <option value={1}>1 배수</option>
                      <option value={2}>2 배수</option>
                      <option value={3}>3 배수</option>
                    </FormSelect>
                  </div>
                )}
                {isSlider && (
                  <div className="wl-field">
                    <label className="wl-field__label">모바일 노출 수</label>
                    <FormSelect name="mobileSlidesPerView" value={this.curWidget.mobileSlidesPerView || 2} onChange={event => this.onChangeValue(event, this.curWidget)}>
                      {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}개</option>)}
                    </FormSelect>
                  </div>
                )}
              </div>

              {/* === 타이틀 노출(+정렬) / 평점 노출 / 리뷰수 노출 — 3col 그리드 각 셀에 좌측 정렬 === */}
              <div className="wl-drawer-field wl-drawer-field--inline wl-drawer-field--gap-top">
                <label className="wl-drawer-field__label">타이틀 노출</label>
                <div className="wl-seg">
                  <button type="button" className={`wl-seg__btn${(this.curWidget.isTitleDis === true || this.curWidget.isTitleDis === 'true') ? ' is-active' : ''}`}
                    onClick={() => this.onChangeValue({target:{name:'isTitleDis', value:'true'}}, this.curWidget)}>노출함</button>
                  <button type="button" className={`wl-seg__btn${!(this.curWidget.isTitleDis === true || this.curWidget.isTitleDis === 'true') ? ' is-active' : ''}`}
                    onClick={() => this.onChangeValue({target:{name:'isTitleDis', value:'false'}}, this.curWidget)}>노출안함</button>
                </div>
                {(this.curWidget.isTitleDis === true || this.curWidget.isTitleDis === 'true') && (
                  <div className="wl-drawer-field__inline-group">
                    <label className="wl-drawer-field__label">정렬</label>
                    <div className="wl-seg">
                      {[{v:'left', i:'align-left'},{v:'center', i:'align-center'},{v:'right', i:'align-right'}].map(o => (
                        <button key={o.v} type="button" className={`wl-seg__btn wl-seg__btn--icon${(this.curWidget.head.style.textAlign === o.v) ? ' is-active' : ''}`}
                          title={o.v}
                          onClick={() => this.onChangeValue({target:{name:'textAlign', value:o.v}}, this.curWidget.head.style)}>
                          <FeatherIcon icon={o.i} size="14" />
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="wl-drawer-field wl-drawer-field--inline wl-drawer-field--vcenter wl-drawer-field--gap-top">
                <label className="wl-drawer-field__label">평점 노출</label>
                <FormCheckbox toggle small
                              checked={!!this.curWidget.display.rating}
                              onChange={() => this.onChangeValue({target:{name:'rating', value: !this.curWidget.display.rating, type:'checkbox', checked: !this.curWidget.display.rating}}, this.curWidget.display)}>
                  {this.curWidget.display.rating ? '노출함' : '노출안함'}
                </FormCheckbox>
              </div>
              <div className="wl-drawer-field wl-drawer-field--inline wl-drawer-field--vcenter wl-drawer-field--gap-top">
                <label className="wl-drawer-field__label">리뷰수 노출</label>
                <FormCheckbox toggle small
                              checked={!!this.curWidget.display.count}
                              onChange={() => this.onChangeValue({target:{name:'count', value: !this.curWidget.display.count, type:'checkbox', checked: !this.curWidget.display.count}}, this.curWidget.display)}>
                  {this.curWidget.display.count ? '노출함' : '노출안함'}
                </FormCheckbox>
              </div>

              {(this.curWidget.isTitleDis === true || this.curWidget.isTitleDis === 'true') && (
              <>
              {/* === 타이틀 설정 (이전: 별도 '타이틀' 탭) === */}
              <div className="wl-detail-grid wl-detail-grid--3col">
                <div className="wl-section-divider"><span className="wl-section-divider__label">타이틀</span></div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">
                    타이틀 <span className="wl-drawer-field__hint-inline">쇼핑몰 표시</span>
                  </label>
                  <FormInput name="title" placeholder="예) BEST 리뷰" value={this.curWidget.head.title} onChange={event => this.onChangeValue(event, this.curWidget.head)} />
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">폰트 크기 <span className="wl-drawer-field__default">PC 23 / MO 16</span></label>
                  <div className="wl-size-pair">
                    <InputGroup>
                      <InputGroupAddon type="prepend"><InputGroupText title="PC"><FeatherIcon icon="monitor" size="12" /></InputGroupText></InputGroupAddon>
                      <FormInput name="size" value={this.curWidget.head.style.size || ''} placeholder="23"
                        onChange={event => this.onChangeValue(event, this.curWidget.head.style)} />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon type="prepend"><InputGroupText title="모바일"><FeatherIcon icon="smartphone" size="12" /></InputGroupText></InputGroupAddon>
                      <FormInput name="sizeMobile" value={this.curWidget.head.style.sizeMobile || ''} placeholder="16"
                        onChange={event => this.onChangeValue(event, this.curWidget.head.style)} />
                    </InputGroup>
                  </div>
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">폰트 색상</label>
                  <div className="wl-color-picker" ref={this.colorSwatchRef_1}>
                    <div className="wl-color-picker__input-row">
                      <span className="wl-color-picker__swatch"
                        style={{ backgroundColor: this.curWidget.head.style.color }}
                        onClick={() => _this.showColorModalFn('isShowMColor_1')}></span>
                      <FormInput value={this.curWidget.head.style.color || ''} placeholder="#000000" readOnly={true}
                        onClick={() => _this.showColorModalFn('isShowMColor_1')} />
                    </div>
                    {this.isShowMColor_1 && ReactDOM.createPortal(
                      <>
                        <div className="wl-color-picker__backdrop" onClick={() => this.isShowMColor_1 = false} />
                        <div className="wl-color-picker__popover"
                          style={{ top: this.colorPickerPos_1.top, left: this.colorPickerPos_1.left }}>
                          <button type="button" className="wl-color-picker__reset"
                            title="색상 초기화"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onChangeColor('color', {hex:''}, this.curWidget.head.style);
                              this.isShowMColor_1 = false;
                            }}>
                            <FeatherIcon icon="x" size="14" />
                          </button>
                          <ChromePicker name="color" disableAlpha={true} color={this.curWidget.head.style.color}
                            onChangeComplete={(color) => this.onChangeColor('color', color, this.curWidget.head.style)} />
                        </div>
                      </>,
                      document.body
                    )}
                  </div>
                </div>
              </div>

              {/* === 서브 타이틀 스타일 === */}
              <div className="wl-detail-grid wl-detail-grid--3col">
                <div className="wl-section-divider"><span className="wl-section-divider__label">서브 타이틀</span></div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">서브 타이틀 <span className="wl-drawer-field__hint-inline">선택</span></label>
                  <FormInput name="subtitle" placeholder="타이틀 아래 부가 설명" value={this.curWidget.head.subtitle || ''} onChange={event => this.onChangeValue(event, this.curWidget.head)} />
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">폰트 크기 <span className="wl-drawer-field__default">PC 14 / MO 12</span></label>
                  <div className="wl-size-pair">
                    <InputGroup>
                      <InputGroupAddon type="prepend"><InputGroupText title="PC"><FeatherIcon icon="monitor" size="12" /></InputGroupText></InputGroupAddon>
                      <FormInput name="size" value={(this.curWidget.head.subtitleStyle || {}).size || ''} placeholder="14"
                        onChange={event => this.onChangeValue(event, this.curWidget.head.subtitleStyle)} />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon type="prepend"><InputGroupText title="모바일"><FeatherIcon icon="smartphone" size="12" /></InputGroupText></InputGroupAddon>
                      <FormInput name="sizeMobile" value={(this.curWidget.head.subtitleStyle || {}).sizeMobile || ''} placeholder="12"
                        onChange={event => this.onChangeValue(event, this.curWidget.head.subtitleStyle)} />
                    </InputGroup>
                  </div>
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">폰트 색상</label>
                  <div className="wl-color-picker" ref={this.colorSwatchRef_2}>
                    <div className="wl-color-picker__input-row">
                      <span className="wl-color-picker__swatch"
                        style={{ backgroundColor: (this.curWidget.head.subtitleStyle || {}).color }}
                        onClick={() => _this.showColorModalFn('isShowMColor_2')}></span>
                      <FormInput value={(this.curWidget.head.subtitleStyle || {}).color || ''} placeholder="#000000" readOnly={true}
                        onClick={() => _this.showColorModalFn('isShowMColor_2')} />
                    </div>
                    {this.isShowMColor_2 && ReactDOM.createPortal(
                      <>
                        <div className="wl-color-picker__backdrop" onClick={() => this.isShowMColor_2 = false} />
                        <div className="wl-color-picker__popover"
                          style={{ top: this.colorPickerPos_2.top, left: this.colorPickerPos_2.left }}>
                          <button type="button" className="wl-color-picker__reset"
                            title="색상 초기화"
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onChangeColor('color', {hex:''}, this.curWidget.head.subtitleStyle);
                              this.isShowMColor_2 = false;
                            }}>
                            <FeatherIcon icon="x" size="14" />
                          </button>
                          <ChromePicker name="color" disableAlpha={true} color={(this.curWidget.head.subtitleStyle || {}).color}
                            onChangeComplete={(color) => this.onChangeColor('color', color, this.curWidget.head.subtitleStyle)} />
                        </div>
                      </>,
                      document.body
                    )}
                  </div>
                </div>
              </div>
              </>
              )}
            </div>
          )}

          {/* 레이아웃 */}
          {active === 'layout' && (
            <div className="wl-detail-pane">
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">
                  최대 너비
                  <span className="wl-drawer-field__default">기본 100%</span>
                </label>
                <InputGroup>
                  <FormInput name="maxWidth" value={this.curWidget.style.maxWidth} placeholder="100%"
                    onChange={event => this.onChangeValue(event, this.curWidget.style)} />
                  <InputGroupAddon type="append"><InputGroupText>px / %</InputGroupText></InputGroupAddon>
                </InputGroup>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">상단 여백 <span className="wl-drawer-field__default">30</span></label>
                <InputGroup>
                  <FormInput name="marginTop" value={this.curWidget.style.marginTop} placeholder="30"
                    onChange={event => this.onChangeValue(event, this.curWidget.style)} />
                  <InputGroupAddon type="append"><InputGroupText>px</InputGroupText></InputGroupAddon>
                </InputGroup>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">하단 여백 <span className="wl-drawer-field__default">30</span></label>
                <InputGroup>
                  <FormInput name="marginBottom" value={this.curWidget.style.marginBottom} placeholder="30"
                    onChange={event => this.onChangeValue(event, this.curWidget.style)} />
                  <InputGroupAddon type="append"><InputGroupText>px</InputGroupText></InputGroupAddon>
                </InputGroup>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">타이틀 좌우 여백 <span className="wl-drawer-field__default">0</span></label>
                <InputGroup>
                  <FormInput name="lrPadding" value={this.curWidget.head.style.lrPadding} placeholder="0"
                    onChange={event => this.onChangeValue(event, this.curWidget.head.style)} />
                  <InputGroupAddon type="append"><InputGroupText>px</InputGroupText></InputGroupAddon>
                </InputGroup>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">타이틀~리스트 간격 <span className="wl-drawer-field__default">30</span></label>
                <InputGroup>
                  <FormInput name="marginBottom" value={this.curWidget.head.style.marginBottom} placeholder="30"
                    onChange={event => this.onChangeValue(event, this.curWidget.head.style)} />
                  <InputGroupAddon type="append"><InputGroupText>px</InputGroupText></InputGroupAddon>
                </InputGroup>
              </div>
              <div className="wl-section-divider">
                <span className="wl-section-divider__label">
                  <FeatherIcon icon="move" size="12" style={{verticalAlign:'-2px', marginRight:4}}/>
                  위젯 배치 설정
                </span>
              </div>
              <div className="wl-detail-grid wl-detail-grid--2col">
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">
                    <FeatherIcon icon="monitor" size="13" style={{verticalAlign:'-2px', marginRight:2}}/>
                    <FeatherIcon icon="smartphone" size="13" style={{verticalAlign:'-2px', marginRight:4}}/>
                    위젯 배치 위치 (PC+모바일) <span className="wl-drawer-field__default">선택 사항</span>
                  </label>
                  <div className="wl-selector-input">
                    <FormInput name="parentSelector" value={this.curWidget.style.parentSelector || ''}
                      onChange={event => this.onChangeValue(event, this.curWidget.style)}
                      placeholder="자동 배치 (또는 CSS 셀렉터 입력)" />
                  </div>
                  <small className="wl-drawer-field__hint">PC와 모바일 공통으로 적용됩니다. 모바일에 별도 위치를 지정하려면 우측에 입력하세요.</small>
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">
                    <FeatherIcon icon="smartphone" size="13" style={{verticalAlign:'-2px', marginRight:4}}/>
                    위젯 배치 위치 (모바일 전용) <span className="wl-drawer-field__default">선택 사항</span>
                  </label>
                  <div className="wl-selector-input">
                    <FormInput name="parentSelectorMobile" value={this.curWidget.style.parentSelectorMobile || ''}
                      onChange={event => this.onChangeValue(event, this.curWidget.style)}
                      placeholder="비워두면 좌측 설정과 동일하게 적용됩니다" />
                  </div>
                  <small className="wl-drawer-field__hint">모바일에서만 적용되는 CSS 셀렉터입니다.</small>
                </div>
              </div>
              <div className="wl-detail-grid wl-detail-grid--2col">
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">
                    <FeatherIcon icon="monitor" size="13" style={{verticalAlign:'-2px', marginRight:2}}/>
                    <FeatherIcon icon="smartphone" size="13" style={{verticalAlign:'-2px', marginRight:4}}/>
                    삽입 방식 (PC+모바일) <span className="wl-drawer-field__default">선택 사항</span>
                  </label>
                  <FormSelect name="insertPosition" value={this.curWidget.style.insertPosition || 'append'}
                    onChange={event => this.onChangeValue(event, this.curWidget.style)}>
                    <option value="append">지정 요소 내부 맨 끝에 추가</option>
                    <option value="prepend">지정 요소 내부 맨 앞에 추가</option>
                    <option value="after">지정 요소 바로 뒤 (형제)</option>
                    <option value="before">지정 요소 바로 앞 (형제)</option>
                    <option value="html">지정 요소의 내용을 교체</option>
                  </FormSelect>
                </div>
                <div className="wl-drawer-field">
                  <label className="wl-drawer-field__label">
                    <FeatherIcon icon="smartphone" size="13" style={{verticalAlign:'-2px', marginRight:4}}/>
                    삽입 방식 (모바일 전용) <span className="wl-drawer-field__default">선택 사항</span>
                  </label>
                  <FormSelect name="insertPositionMobile" value={this.curWidget.style.insertPositionMobile || ''}
                    onChange={event => this.onChangeValue(event, this.curWidget.style)}>
                    <option value="">좌측 설정과 동일</option>
                    <option value="append">지정 요소 내부 맨 끝에 추가</option>
                    <option value="prepend">지정 요소 내부 맨 앞에 추가</option>
                    <option value="after">지정 요소 바로 뒤 (형제)</option>
                    <option value="before">지정 요소 바로 앞 (형제)</option>
                    <option value="html">지정 요소의 내용을 교체</option>
                  </FormSelect>
                </div>
              </div>
            </div>
          )}

          {/* 슬라이드 (slider 타입일 때만) — 3열 정렬 */}
          {active === 'slide' && isSlider && (
            <div className="wl-detail-pane">
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">자동 슬라이드</label>
                <FormSelect name="isAutoPlay" value={this.curWidget.isAutoPlay}
                            onChange={event => this.onChangeDataValue(this.curWidget, event)}>
                  <option value={true}>사용</option>
                  <option value={false}>사용안함</option>
                </FormSelect>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">
                  슬라이드 전환 속도
                  <span className="wl-drawer-field__value">{this.curWidget.slideDelay || 3000}ms</span>
                </label>
                <input type="range" className="wl-range" name="slideDelay" min="500" max="10000" step="100"
                  value={this.curWidget.slideDelay || 3000}
                  onChange={event => this.onChangeValue(event, this.curWidget)} />
                <div className="wl-range__labels"><span>빠름 500ms</span><span>느림 10000ms</span></div>
              </div>
              <div className="wl-drawer-field">
                <label className="wl-drawer-field__label">이동 슬라이드 수</label>
                <FormSelect name="slidesToScroll" value={this.curWidget.slidesToScroll || 1} onChange={event => this.onChangeValue(event, this.curWidget)}>
                  {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}개씩</option>)}
                </FormSelect>
              </div>
            </div>
          )}

          {/* 저장/되돌리기는 카드 펼침 영역 상단의 wl-sticky-save 알림 바에서 처리됨 */}
        </div>
      </div>
    );
  };

  render() {
    let _this = this;

    function Pagination() {
      if (!(_this.list && _this.list.totalPages)) return (<></>);
      const totalPages = _this.list.totalPages;
      const curPageNum = _this.list.page;
      const startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
      const endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;
      const go = (p) => (e) => { if(e) e.preventDefault(); _this.listParams.page = p; _this.getWidgetList(); };

      const items = [];
      for (let i = startNum; i <= endNum; i++) {
        items.push(
          <li key={i} className={i === curPageNum ? 'on' : ''}>
            <a href={"#page=" + i} onClick={go(i)}>{i}</a>
          </li>
        );
      }
      return (
        <div className="pagination">
          <ul>
            {curPageNum !== 1 ? (
              <li className="btn-page-first"><a href="#page=1" onClick={go(1)}><FeatherIcon icon="chevrons-left" className="nd-icon"/></a></li>
            ) : null}
            {startNum - 1 > 0 ? (
              <li className="btn-page-prev"><a href={'#page=' + (startNum - 1)} onClick={go(startNum - 1)}><FeatherIcon icon="chevron-left" className="nd-icon"/></a></li>
            ) : null}
            {items}
            {endNum !== totalPages ? (
              <li className="btn-page-next"><a href={'#page=' + (startNum + 10)} onClick={go(startNum + 10)}><FeatherIcon icon="chevron-right" className="nd-icon"/></a></li>
            ) : null}
            {curPageNum !== totalPages ? (
              <li className="btn-page-last"><a href={'#page=' + totalPages} onClick={go(totalPages)}><FeatherIcon icon="chevrons-right" className="nd-icon"/></a></li>
            ) : null}
          </ul>
        </div>
      );
    }

    // Helper: display area label
    const getDisplayAreaLabel = (key) => {
      const found = displayAreaProps.find(d => d.key === key);
      return found ? found.label : key;
    };

    // Helper: review type label
    const getReviewTypeLabel = (key) => {
      const found = reviewTypeProps.find(d => d.key === key);
      return found ? found.label : key;
    };

    // 페이지 탭 정의 — widgetByPage.js의 pageTabProps와 동일 구조로 맞춤
    const pageTabs = [
      {key: 'main', label: '메인', icon: 'home', areas: ['main']},
      {key: 'list', label: '카테고리', icon: 'category', areas: ['list']},
      {key: 'detail', label: '상품 상세페이지', icon: 'shopping_bag', areas: ['detail_top', 'detail_top_all']},
      {key: 'board', label: '리뷰 게시판', icon: 'rate_review', areas: ['board_top']},
      {key: 'code', label: '코드로 사용', icon: 'code', areas: ['code']},
      {key: 'all', label: '전체', icon: 'apps', areas: null},
    ];
    const curPageTab = pageTabs.find(t => t.key === this.widgetPageTab) || pageTabs[0];

    // Helpers: filters
    const kw = (this.widgetKeyword || '').trim().toLowerCase();
    const filterFn = (item) => {
      if (curPageTab.areas && !curPageTab.areas.includes(item.displayArea)) return false;
      if (this.widgetTypeFilter && item.type !== this.widgetTypeFilter) return false;
      if (this.widgetStatusFilter === 'on' && !(item.isDisplay === true || item.isDisplay === 'true')) return false;
      if (this.widgetStatusFilter === 'off' && (item.isDisplay === true || item.isDisplay === 'true')) return false;
      if (kw) {
        const title = (item.title || '').toLowerCase();
        const headTitle = (item.head && item.head.title ? item.head.title : '').toLowerCase();
        if (!title.includes(kw) && !headTitle.includes(kw)) return false;
      }
      return true;
    };
    const hasFilter = !!(this.widgetTypeFilter || this.widgetStatusFilter || kw || this.widgetPageTab !== 'all');
    const rawDocs = (this.list && this.list.docs) ? this.list.docs : [];
    const filteredDocs = rawDocs.filter(filterFn);
    // 페이지 탭별 카운트 (다른 필터는 무시, areas 만 비교해 각 탭의 총 위젯 수 표시)
    const pageTabCounts = {};
    pageTabs.forEach(t => {
      pageTabCounts[t.key] = t.areas === null
        ? rawDocs.length
        : rawDocs.filter(d => t.areas.includes(d.displayArea)).length;
    });
    const resetFilters = () => {
      this.widgetKeyword = '';
      this.widgetTypeFilter = '';
      this.widgetStatusFilter = '';
      this.widgetPageTab = 'all';
    };

    return (
      <div className="main-content">
        <PageTitle />

        {(this.isLogin && this.teamUser && !this.teamUser.isPaidShop) && (
          <div className="es-paywall-banner">
            <FeatherIcon icon="lock" size="14"/>
            <span><strong>위젯 목록은 무료로 확인</strong>할 수 있습니다. 위젯 활성화 / 설정 변경은 <strong>유료 플랜 전용</strong>입니다.</span>
            <button type="button" className="es-paywall-banner__cta"
                    onClick={() => { window.location.href = '/inAppOrder'; }}>
              <FeatherIcon icon="credit-card" size="13"/>
              결제페이지로 이동하기
              <FeatherIcon icon="arrow-right" size="13"/>
            </button>
          </div>
        )}

        <div className="wl-page">

          {/* Header area */}
          <div className="wl-header">
            <div className="wl-header__left"></div>
            <div className="wl-header__right">
              <Button className="wl-btn wl-btn--primary" size="sm" onClick={() => this.openNewWidgetModal()}>
                <FeatherIcon icon="plus" size="14" /> 그리드 위젯 추가
              </Button>
            </div>
          </div>

          {/* Dismissible info banner */}
          {this.showBanner && (
            <div className="wl-banner">
              <FeatherIcon icon="info" size="14" />
              <span className="wl-banner__text">다양한 페이지에서 추가 위젯을 사용해 보세요. 위젯을 추가하면 쇼핑몰에 리뷰를 노출할 수 있습니다.</span>
              <button type="button" className="wl-banner__close" onClick={() => { this.showBanner = false; }}>
                <FeatherIcon icon="x" size="14" />
              </button>
            </div>
          )}

          {/* Page tabs (페이지별 탭) — widgetByPage와 동일한 UI */}
          <div className="widget-page-tabs">
            <div className="page-tab-header">
              <h3>페이지별 위젯 목록</h3>
              <p>위젯을 조회할 페이지를 선택하세요</p>
            </div>
            <div className="page-tab-list">
              {pageTabs.map(t => {
                const active = this.widgetPageTab === t.key;
                return (
                  <div key={t.key}
                       className={`page-tab-item ${active ? 'active' : ''}`}
                       onClick={() => { this.widgetPageTab = t.key; }}>
                    <i className="material-icons page-tab-icon">{t.icon}</i>
                    <span className="page-tab-label">
                      {t.label}
                      <span className="page-tab-count">{pageTabCounts[t.key] || 0}</span>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Card view (유일 뷰) */}
          <div className="wl-card-list">
            {rawDocs.length > 0 && filteredDocs.length > 0 ?
              filteredDocs.map((item, i) => {
                const isExpanded = this.expandedCard === item._id;
                const isOn = item.isDisplay === true || item.isDisplay === 'true';
                const typeLabel = this.makeWidgetProps[item.type] ? this.makeWidgetProps[item.type].label : item.type;
                const isSlider = item.type === 'slider';

                return (
                  <div className={`wl-card ${isExpanded ? 'wl-card--expanded' : ''}`} key={item._id || i}>
                    <div className="wl-card__main" onClick={() => this.toggleCardExpand(item._id)}>

                      {/* Center info */}
                      <div className="wl-card__info">
                        <div className="wl-card__name-row">
                          {this.editingNameId === item._id ? (
                            <input
                              type="text"
                              className="wl-card__name-input"
                              autoFocus
                              value={this.editingNameValue}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                              onChange={(e) => this.editingNameValue = e.target.value}
                              onBlur={() => this.commitEditName(item)}
                              onKeyDown={(e) => this.handleNameKeyDown(e, item)}
                              onFocus={(e) => e.target.select()}
                              placeholder="위젯 이름"
                            />
                          ) : (
                            <span
                              className="wl-card__name wl-card__name--editable"
                              onClick={(e) => this.startEditName(item, e)}
                              title="클릭하여 이름 수정"
                            >
                              <span className="wl-card__name-text">
                                {item.title || (item.type === 'ai_floating' ? 'AI 분석 플로팅 위젯' : '기본 위젯')}
                              </span>
                              <FeatherIcon icon="edit-2" size="12" className="wl-card__name-edit-icon" />
                            </span>
                          )}
                          <span className={`wl-badge ${isSlider ? 'wl-badge--purple' : 'wl-badge--blue'}`}>
                            {typeLabel}
                          </span>
                        </div>
                        {item.head && item.head.title && (
                          <div className="wl-card__display-name">{item.head.title}</div>
                        )}
                        {item.product_id && item.product_id.productName && (
                          <div className="wl-card__product">
                            <a href={"/productWidgetList?product_id=" + item.product_id._id}>{item.product_id.productName}</a>
                          </div>
                        )}
                        <div className="wl-card__meta">
                          <span className="wl-card__meta-item">
                            <FeatherIcon icon="monitor" size="12" /> {getDisplayAreaLabel(item.displayArea)}
                          </span>
                          <span className="wl-card__meta-item">
                            <FeatherIcon icon="grid" size="12" /> {item.col}x{item.row}
                          </span>
                          <span className="wl-card__meta-item">
                            <FeatherIcon icon="image" size="12" /> {getReviewTypeLabel(item.reviewType || 'photo')}
                          </span>
                        </div>
                      </div>

                      {/* Status toggle */}
                      <div className="wl-card__toggle-wrap" onClick={e => e.stopPropagation()}>
                        <label className={`wl-toggle ${isOn ? 'wl-toggle--on' : ''}`}>
                          <input
                            type="checkbox"
                            checked={isOn}
                            disabled={!this.isUse && !isOn}
                            onChange={() => {
                              const syntheticEvent = { target: { name: 'isDisplay', value: isOn ? 'false' : 'true' } };
                              this.onChangeDataValue(item, syntheticEvent);
                            }}
                          />
                          <span className="wl-toggle__slider"></span>
                          <span className="wl-toggle__label">{isOn ? 'ON' : 'OFF'}</span>
                        </label>
                      </div>

                      {/* Actions */}
                      <div className="wl-card__actions" onClick={e => e.stopPropagation()}>
                        {item.displayArea === 'code' && (
                          <button className="wl-icon-btn" title="코드복사" onClick={() => this.onCopyWidgetCode(item)}>
                            <FeatherIcon icon="copy" size="16" />
                          </button>
                        )}
                        {item.selecting === 'specify' && (
                          <button className="wl-icon-btn" title="리뷰보기" onClick={() => this.onShowReviews(item)}>
                            <FeatherIcon icon="eye" size="16" />
                          </button>
                        )}
                      </div>

                      {/* Expand indicator */}
                      <div className="wl-card__expand-icon">
                        <FeatherIcon icon={isExpanded ? 'chevron-up' : 'chevron-down'} size="16" />
                      </div>
                    </div>

                    {/* Accordion: quick-edit fields */}
                    {isExpanded && (
                      <div className="wl-card__expand">
                        {/* 저장되지 않은 변경사항 알림 — widgetByPage 의 sticky-save 패턴 */}
                        {this.isWidgetDirty(item._id) && (
                          <div className="wl-sticky-save" onClick={e => e.stopPropagation()}>
                            <div className="wl-sticky-save__msg">
                              <FeatherIcon icon="alert-circle" size="14" />
                              <span>저장되지 않은 변경사항이 있습니다.</span>
                            </div>
                            <div className="wl-sticky-save__actions">
                              <Button theme="light" size="sm" onClick={() => this.revertWidget(item)}>되돌리기</Button>
                              <Button theme="primary" size="sm" onClick={() => this.onChangeStyleValue(item)}>저장</Button>
                            </div>
                          </div>
                        )}

                        {/* 데이터 항목(리뷰 선택/타입/노출 영역/종류/라인 수/슬라이드) 은 renderDetailedSettings 의 "기본" 탭으로 이동 */}
                        {this.curWidget && this.curWidget._id === item._id && this.renderDetailedSettings()}

                        <div className="wl-card__expand-footer">
                          <button type="button" className="wl-card__delete-btn" onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm('\'' + (item.title || '위젯') + '\' 위젯을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) {
                              this.onRemoveWidget(item);
                            }
                          }}>
                            <FeatherIcon icon="trash-2" size="13" /> 위젯 삭제
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
              :
              /* Empty state */
              (rawDocs.length > 0 && hasFilter ? (
                <div className="wl-empty">
                  <div className="wl-empty__icon">
                    <FeatherIcon icon="search" size="48" />
                  </div>
                  <h3 className="wl-empty__title">조건에 맞는 위젯이 없습니다</h3>
                  <p className="wl-empty__desc">검색어나 필터를 변경해 보세요.</p>
                  <Button className="wl-btn wl-btn--secondary" onClick={resetFilters}>
                    <FeatherIcon icon="rotate-ccw" size="14" /> 필터 초기화
                  </Button>
                </div>
              ) : (
                <div className="wl-empty">
                  <div className="wl-empty__icon">
                    <FeatherIcon icon="layout" size="48" />
                  </div>
                  <h3 className="wl-empty__title">첫 번째 리뷰 위젯을 만들어 보세요!</h3>
                  <p className="wl-empty__desc">위젯을 추가하면 쇼핑몰에 리뷰를 노출할 수 있습니다.</p>
                  <Button className="wl-btn wl-btn--primary" onClick={() => this.openNewWidgetModal()}>
                    <FeatherIcon icon="plus" size="14" /> 위젯 만들기
                  </Button>
                </div>
              ))
            }
          </div>

          <Pagination/>
        </div>


        {/* ===== "위젯 만들기" Modal ===== */}
        <Modal size="lg" className='wl-modal-create' open={this.modals.isNewWidget} toggle={() => this.modals.isNewWidget = false} centered={true}>
          <ModalHeader toggle={() => this.modals.isNewWidget = false}>
            <span className="wl-modal__title">위젯 만들기</span>
          </ModalHeader>
          <ModalBody>
            <div className="wl-form">
              {this.makeWidgetProps && (
                <div className="wl-form__group">
                  <label className="wl-form__label">종류</label>
                  <FormSelect name="type" value={this.newWidget.type} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {Object.keys(this.makeWidgetProps).filter(key => key !== 'purchase_review').map((key, i) => (
                      <option key={key} value={key}>{this.makeWidgetProps[key].label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
              <div className="wl-form__group">
                <label className="wl-form__label">타이틀</label>
                <FormInput name="title" placeholder="제목" value={this.newWidget.title} onChange={event => this.onChangeValue(event, this.newWidget)} />
              </div>
              <div className="wl-form__group">
                <label className="wl-form__label">타이틀 노출</label>
                <FormSelect name="isTitleDis" value={this.newWidget.isTitleDis} onChange={event => this.onChangeValue(event, this.newWidget)}>
                  {this.newWidgetProps.isTitleDis.map((item, key) => (
                    <option key={key} value={item.key}>{item.label}</option>
                  ))}
                </FormSelect>
              </div>
              {this.newWidgetProps && this.newWidgetProps.selecting && (
                <div className="wl-form__group">
                  <label className="wl-form__label">리뷰 선택</label>
                  <FormSelect name="selecting" value={this.newWidget.selecting} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {this.newWidgetProps.selecting.map((item, key) => (
                      <option key={key} value={item.key}>{item.label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
              {this.newWidgetProps && this.newWidgetProps.reviewType && (
                <div className="wl-form__group">
                  <label className="wl-form__label">리뷰 타입</label>
                  <FormSelect name="reviewType" value={this.newWidget.reviewType} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {this.newWidgetProps.reviewType.map((item, key) => (
                      <option key={key} value={item.key}>{item.label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
              {this.newWidgetProps && this.newWidgetProps.displayArea && (
                <div className="wl-form__group">
                  <label className="wl-form__label">노출 영역</label>
                  <FormSelect name="displayArea" value={this.newWidget.displayArea} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {this.newWidgetProps.displayArea.map((item, key) => (
                      <option key={key} value={item.key}>{item.label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
              <div className="wl-form__row">
                {this.newWidgetProps && this.newWidgetProps.col && (
                  <div className="wl-form__group wl-form__group--half">
                    <label className="wl-form__label">라인당 리뷰수</label>
                    <FormSelect name="col" value={this.newWidget.col} onChange={event => this.onChangeValue(event, this.newWidget)}>
                      {this.newWidgetProps.col.map((item, key) => (
                        <option key={key} value={item.key}>{item.label}</option>
                      ))}
                    </FormSelect>
                  </div>
                )}
                {this.newWidgetProps && this.newWidgetProps.row && (
                  <div className="wl-form__group wl-form__group--half">
                    <label className="wl-form__label">라인 수</label>
                    <FormSelect name="row" value={this.newWidget.row} onChange={event => this.onChangeValue(event, this.newWidget)}>
                      {this.newWidgetProps.row.map((item, key) => (
                        <option key={key} value={item.key}>{item.label}</option>
                      ))}
                    </FormSelect>
                  </div>
                )}
              </div>
              {this.newWidgetProps && this.newWidgetProps.isAutoPlay && this.newWidget.type === "slider" && (
                <div className="wl-form__group">
                  <label className="wl-form__label">자동 슬라이드</label>
                  <FormSelect name="isAutoPlay" value={this.newWidget.isAutoPlay} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {this.newWidgetProps.isAutoPlay.map((item, key) => (
                      <option key={key} value={item.key}>{item.label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
              {this.newWidgetProps && this.newWidgetProps.isDisplay && (
                <div className="wl-form__group">
                  <label className="wl-form__label">노출 여부</label>
                  <FormSelect name="isDisplay" value={this.newWidget.isDisplay} onChange={event => this.onChangeValue(event, this.newWidget)}>
                    {this.newWidgetProps.isDisplay.map((item, key) => (
                      <option key={key} value={item.key}>{item.label}</option>
                    ))}
                  </FormSelect>
                </div>
              )}
            </div>
            <div className="wl-modal__footer">
              <Button className="wl-btn wl-btn--secondary" onClick={event => this.modals.isNewWidget = false}>취소</Button>
              <Button className="wl-btn wl-btn--primary" onClick={event => this.updateWidget()}>저장</Button>
            </div>
          </ModalBody>
        </Modal>

        {/* "위젯 세부 설정" Drawer 제거됨 — 카드 펼침 영역의 renderDetailedSettings()로 통합 */}

        {/* ===== 위치 선택기 모달 ===== */}
        {this.selectorPickerOpen && (
          <Modal size="lg" className="wl-picker-modal" open={this.selectorPickerOpen} toggle={() => {}}>
            <div className="wl-picker">
              <div className="wl-picker__header">
                <div>
                  <h3 className="wl-picker__title">쇼핑몰 페이지에서 위치 선택</h3>
                  <p className="wl-picker__subtitle">원하는 영역을 클릭하면 해당 위치의 셀렉터가 자동으로 추출됩니다.</p>
                </div>
                <button type="button" className="wl-picker__close" onClick={() => this.closeSelectorPicker()}>
                  <FeatherIcon icon="x" size="20" />
                </button>
              </div>
              {this.selectorPickerSelected && (
                <div className="wl-picker__selected">
                  <FeatherIcon icon="crosshair" size="14" />
                  <span>선택된 셀렉터: </span>
                  <code>{this.selectorPickerSelected}</code>
                </div>
              )}
              <div className="wl-picker__body">
                {this.selectorPickerLoading ? (
                  <div className="wl-picker__loading">
                    <span className="wl-picker__spinner" />
                    <span>쇼핑몰 페이지를 불러오는 중...</span>
                  </div>
                ) : (
                  <iframe
                    ref={this.setupPickerIframe}
                    className="wl-picker__iframe"
                    srcDoc={this.selectorPickerHtml}
                    sandbox="allow-same-origin"
                    title="쇼핑몰 프리뷰"
                  />
                )}
              </div>
              <div className="wl-picker__footer">
                <span className="wl-picker__url">
                  <FeatherIcon icon="globe" size="12" /> {this.selectorPickerUrl}
                </span>
                <div className="wl-picker__footer-actions">
                  <button type="button" className="wl-btn wl-btn--ghost" onClick={() => this.closeSelectorPicker()}>취소</button>
                  <button type="button" className="wl-btn wl-btn--primary" disabled={!this.selectorPickerSelected} onClick={() => this.applySelectorFromPicker()}>
                    <FeatherIcon icon="check" size="14" /> 이 위치에 배치
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}

        {/* 노하우 안내 — 페이지 하단 아코디언 (기본 접힘) */}
        <details className="wl-knowhow">
          <summary>
            <span className="wl-knowhow__icon" aria-hidden="true">
              <FeatherIcon icon="zap" size="14"/>
            </span>
            <span className="wl-knowhow__label">노하우</span>
            <span className="wl-knowhow__divider"/>
            <span className="wl-knowhow__title">원하는 상품 리뷰만 위젯에 노출하는 방법</span>
            <FeatherIcon icon="chevron-down" size="16" className="wl-knowhow__chev"/>
          </summary>
          <div className="wl-knowhow__body">
            <ol className="wl-knowhow__steps">
              <li>
                <span className="wl-knowhow__step-num">1</span>
                <div className="wl-knowhow__step-body">
                  해당 위젯의 <strong>설정</strong>에서 <code>리뷰 선택</code> 항목을 <strong>"지정"</strong>으로 변경합니다.
                </div>
              </li>
              <li>
                <span className="wl-knowhow__step-num">2</span>
                <div className="wl-knowhow__step-body">
                  좌측 메뉴의 <strong>리뷰/답글 &gt; <Link to="/reviewList" target="_blank" rel="noopener noreferrer">리뷰 리스트</Link></strong> 페이지로 이동합니다.
                </div>
              </li>
              <li>
                <span className="wl-knowhow__step-num">3</span>
                <div className="wl-knowhow__step-body">
                  노출하고 싶은 리뷰를 선택한 뒤, 우측 <strong>"위젯 추가"</strong>에서 방금 만든 위젯을 선택하면 해당 리뷰만 위젯에 표시됩니다.
                </div>
              </li>
            </ol>
            <div className="wl-knowhow__actions">
              <Link to="/reviewList" target="_blank" rel="noopener noreferrer" className="wl-knowhow__cta">
                <FeatherIcon icon="external-link" size="12"/>
                리뷰 리스트로 이동
              </Link>
            </div>
          </div>
        </details>

      </div>
    )
  }
}

export default widgetList;
